import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  container: (props: any) => ({
    display: props.open ? "flex" : "none",
    flexDirection: "column",
    rowGap: "1rem",
    height: "max-content",
    minWidth: props.open ? "18rem" : "0",
    maxWidth: props.open ? "18rem" : "0",
    marginRight: props.open ? "2rem" : 0,
    pointerEvents: props.open ? "initial" : "none",
    color: theme.darkSlateGrayColor,
    // maxHeight: "calc(100vh - 20rem)",
  }),
  btnContainer: {
    display: "flex",
    flexDirection: "column",
    alignContent: "center",
    rowGap: "1.5rem",
    padding: "1rem",
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: "2rem",
    position: "sticky",
    top: "2rem",
    zIndex: 1,
    backgroundColor: theme.whiteColor,
    borderBottom: `1px solid ${theme.lighterSnowColor}`,
  },
  clearBtn: {
    border: "none",
    padding: 0,
    width: "max-content",
    height: "1rem",
    backgroundColor: "inherit",
    color: theme.darkSlateGrayColor,
    fontSize: "1rem",
    fontFamily: theme.fontFamilyQuestrial,
    textDecoration: "underline",
    cursor: "pointer",
  },
  showResult: (props: any) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "3rem",
    width: props.matches ? "100%" : "100%",
    padding: 0,
    border: "none",
    borderRadius: "7px",
    textDecoration: "none",
    color: theme.whiteColor,
    background: `linear-gradient(to right, ${theme.blanchedAlmondColor}, ${theme.peachPuffColor})`,
    textTransform: "uppercase",
    fontSize: "0.9rem",
    fontWeight: 500,
    fontFamily: theme.fontFamilyArchivo,
    cursor: "pointer",
  }),
  filterContainer: (props: any) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minHeight: "10rem",
    overflowY: "auto",
    position: "relative",

    "&::-webkit-scrollbar": {
      width: props.matches ? "0.5rem" : "0.2rem",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "none",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.snowColor,
      borderRadius: "0.2rem",
    },
    "&:hover::-webkit-scrollbar-thumb": {
      backgroundColor: theme.gainsboroColor,
    },
  }),
  subFilterContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "1rem",
    // paddingTop: "2rem",
    rowGap: "1rem",

    "&:not(:first-child)": {
      borderTop: `1px solid ${theme.lighterSnowColor}`,
    },
  },
  subFilterTitleAndExpand: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    cursor: "pointer",
  },
  subFilterTitle: {
    display: "flex",
    alignItems: "center",
    fontWeight: 400,
  },
  dot: {
    width: "7px",
    height: "7px",
    alignSelf: "flex-start",
    marginTop: "4px",
    marginLeft: "4px",
    borderRadius: "50%",
    backgroundColor: theme.lightCoralColor,
  },
  expanded: {
    display: "flex",
    alignItems: "center",
  },
  filterElementContainer: {
    display: "flex",
    flexDirection: "column",
    rowGap: "0.5rem",
    marginBottom: "0.5rem",
    fontFamily: theme.fontFamilyQuestrial,
    "& > label": {
      display: "flex",
      justifyContent: "space-between",
    },
  },
  showMore: {
    textDecoration: "underline",
    color: theme.lightCoralColor,
    "& > span": {
      cursor: "pointer",
    },
  },
  element: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  elementLabel: (props: any) => ({
    display: "flex",
    alignItems: "center",
    textTransform: "capitalize",
    cursor: "pointer",
    "& input": {
      display: "none",
    },
    "& input + div": {
      minWidth: "0.8rem",
      minHeight: "0.8rem",
      backgroundColor: props.checked
        ? theme.darkSlateGrayColor
        : theme.whiteColor,
      border: props.checked
        ? `1px solid ${theme.darkSlateGrayColor}`
        : `1px solid ${theme.dimGrayColor}`,
      marginRight: "0.7rem",
    },
  }),
}));

export default useStyles;
